import { memo } from 'react'

import { SVGProps } from './types/iconType'

export const HeatmapIcon = memo(({ style, className }: SVGProps) => {
  return (
    <svg style={style} className={className} viewBox="0 0 32 32" id="icon" xmlns="http://www.w3.org/2000/svg">
      <path d="M27,3H5A2.0023,2.0023,0,0,0,3,5V27a2.0023,2.0023,0,0,0,2,2H27a2.0023,2.0023,0,0,0,2-2V5A2.0023,2.0023,0,0,0,27,3ZM19,9H13V5h6Zm0,2v4H13V11Zm-8,0v4H5V11Zm0,6v4H5V17Zm2,0h6v4H13Zm8-2V11h6l0,4ZM5,23h6v4H5Zm16,4V23h6v4Z" />
      <rect
        id="_Transparent_Rectangle_"
        data-name="&lt;Transparent Rectangle&gt;"
        style={{ fill: 'none' }}
        width="32"
        height="32"
      />
    </svg>
  )
})
